import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import Icon1_1 from './icons/Icon1_1';
import Icon1_2 from './icons/Icon1_2';
import Icon1_3 from './icons/Icon1_3';
import Icon1_4 from './icons/Icon1_4';
import Icon1_5 from './icons/Icon1_5';
import Icon2_1 from './icons/Icon2_1';
import Icon2_2 from './icons/Icon2_2';
import Icon2_3 from './icons/Icon2_3';
import Icon2_4 from './icons/Icon2_4';
import Icon2_5 from './icons/Icon2_5';
import css from './index.module.scss';
import { useEffect, useRef } from 'react';

const VS: React.FC = () => {
    const { t } = useLang('shp3.VS');

    const imgs = [
        { pc: 'https://websiteoss.ecoflow.com/upload/image/1759029937037/Smart%20Home%20Panel%203.png' },
        { pc: 'https://websiteoss.ecoflow.com/upload/image/1759029936808/Traditional%20Panel%20(1).png' },
    ];

    const IconsArray1 = [<Icon1_1 />, <Icon1_2 />, <Icon1_3 />, <Icon1_4 />, <Icon1_5 />];
    const IconsArray2 = [<Icon2_1 />, <Icon2_2 />, <Icon2_3 />, <Icon2_4 />, <Icon2_5 />];
    const list = new Array(2).fill(null).map((item, index) => {
        return {
            title: t(`item${index + 1}`),

            rows: new Array(5).fill(null).map((row, key) => {
                return {
                    title: t(`item${index + 1}_row${key + 1}_title`),
                    desc: t(`item${index + 1}_row${key + 1}_desc`),
                    icon: index === 0 ? IconsArray1[key] : IconsArray2[key],
                };
            }),
        };
    });
    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!sectionRef.current) return;
        const ani1El = sectionRef.current?.querySelectorAll('.ani-1');
        const ani2El = sectionRef.current?.querySelectorAll('.ani-2');
        const ani3El = sectionRef.current?.querySelectorAll('.ani-3');

        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                ani1El.forEach((el) => el?.classList.add('enter'));
                ani2El.forEach((el) => el?.classList.add('enter'));
                ani3El.forEach((el) => el?.classList.add('enter'));
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    ani1El.forEach((el) => el?.classList.remove('enter'));
                    ani2El.forEach((el) => el?.classList.remove('enter'));
                    ani3El.forEach((el) => el?.classList.remove('enter'));
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <section className={`${css.section} shp3-Q GtmModuleData-section`} data-section-id={'shp3-Q'}>
            <div className="box" ref={sectionRef}>
                {list.map((item, index) => {
                    return (
                        <div className={`box-item box-item${index + 1} `}>
                            <EcoImg pc={imgs[index].pc} className={`ani-1`} isOpenLazy />
                            <p className={`title ani-2`}>{item.title}</p>
                            <div className={`items items-${index + 1} ani-3`}>
                                {item.rows.map((row, key) => {
                                    return (
                                        <div className={`item item-${key + 1}`}>
                                            <p className="icon">{row.icon}</p>
                                            <div>
                                                <p className="item-title">{row.title}</p>
                                                <p className="item-desc">{row.desc}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
            <EcoSpace />
        </section>
    );
};

export default VS;
